import React from 'react';
import { Footprints, Construction } from 'lucide-react';

const GlassPanel: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <div className={`bg-white/5 backdrop-blur-2xl border border-white/10 rounded-2xl overflow-hidden shadow-2xl p-6 ${className}`}>{children}</div>
);

export function Footfall() {
  const periods = [
    { label: 'Today', value: 0 },
    { label: 'This Week', value: 0 },
    { label: 'This Month', value: 0 },
    { label: 'This Year', value: 0 },
    { label: 'All Time', value: 0 }
  ];

  return (
    <div className="min-h-screen bg-[#0a0b14] text-white p-6 space-y-8 pb-32">
      <div>
        <h1 className="text-3xl font-black tracking-tighter uppercase flex items-center gap-3"><Footprints className="w-8 h-8 text-blue-400" /> Footfall</h1>
        <p className="text-sm text-blue-100/40 mt-1 font-medium tracking-wide">Visitor traffic and demographic insight across your locations.</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
        {periods.map(p => (
          <GlassPanel key={p.label} className="text-center">
            <p className="text-[10px] uppercase tracking-widest text-blue-100/40 font-bold mb-2">{p.label}</p>
            <h4 className="text-3xl font-black text-white">{p.value}</h4>
          </GlassPanel>
        ))}
      </div>

      <GlassPanel className="flex flex-col items-center justify-center text-center py-20">
        <div className="w-16 h-16 rounded-2xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-6">
          <Construction className="w-7 h-7 text-blue-400" />
        </div>
        <h3 className="text-sm font-black uppercase tracking-widest text-white mb-2">AI Model Not Yet Connected</h3>
        <p className="text-xs text-blue-100/40 max-w-md leading-relaxed">
          Footfall demographics (visitor counting, age/gender estimation) needs a dedicated AI model that isn't wired up yet. This page is ready to display live data the moment that model is integrated.
        </p>
      </GlassPanel>
    </div>
  );
}
